import { render, staticRenderFns } from "./modular.vue?vue&type=template&id=3a5df2c3&scoped=true&"
import script from "./modular.vue?vue&type=script&lang=js&"
export * from "./modular.vue?vue&type=script&lang=js&"
import style0 from "./modular.vue?vue&type=style&index=0&id=3a5df2c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5df2c3",
  null
  
)

component.options.__file = "modular.vue"
export default component.exports